const toCamelCase = (str)=>str.replace(/-([a-z])/g, (_, char)=>char.toUpperCase());
const toPascalCase = (str)=>{
    const camelCase = toCamelCase(str);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
function mapClass(values, key) {
    const classNameMap = new Map();
    for (const value of values)classNameMap.set(value, `${key}${toPascalCase(value)}`);
    return Object.fromEntries(classNameMap);
}
export { mapClass, toCamelCase, toPascalCase };

//# sourceMappingURL=mapClass.js.map